import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { ScAuditHistoryModule } from './audit-history/audit-history.module';
import { CommonModule } from '@angular/common';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    BrowserModule,
    ScAuditHistoryModule
  ],
  providers: [],
  bootstrap: []
})
export class AppModule {
  constructor() { }

  // ngDoBootstrap needs to do nothing when exporting custom elements so that the normal Angular app bootstrap doesn't take place
  ngDoBootstrap() { }
}
